import React from 'react';
import { TopBar, Hero, Problem, Transformation } from './components/HeroProblem';
import { Benefits, ProductBreakdown, Bonuses } from './components/ProductBenefits';
import { Testimonials, Offer, FAQ, FinalCTA } from './components/OfferTrust';
export function App() {
  return <div className="min-h-screen bg-dark-bg font-sans selection:bg-brand-500/30 selection:text-white" data-id="element-0">
      <TopBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problem data-id="element-4" />
        <Transformation data-id="element-5" />
        <Benefits data-id="element-6" />
        <ProductBreakdown data-id="element-7" />
        <Bonuses data-id="element-8" />
        <Testimonials data-id="element-9" />
        <Offer data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <footer className="bg-dark-bg border-t border-dark-border py-8 text-center text-gray-500 text-sm" data-id="element-13">
        <div className="max-w-6xl mx-auto px-4" data-id="element-14">
          <p data-id="element-15">
            © {new Date().getFullYear()} La Biblia del Backtest. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs" data-id="element-16">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}